<template>
    <div class="flex flex-wrap justify-center lg:justify-end items-center space-x-0 sm:space-x-16 mb-8">
        <!-- font sizes -->
        <div class="flex w-full sm:w-auto items-end justify-center lg:justify-end space-x-4 font-bold py-3 lg:py-0">
            <div class="transition-all duration-500 cursor-pointer hover:opacity-50" @click="changeFontSize('small')">
                <img :src="`${url}/gfx/font-size-small.png`" alt="mały tekst" />
            </div>
            <div class="transition-all duration-500 cursor-pointer hover:opacity-50" @click="changeFontSize('normal')">
                <img :src="`${url}/gfx/font-size-normal.png`" alt="normalny tekst" />
            </div>
            <div class="transition-all duration-500 cursor-pointer hover:opacity-50" @click="changeFontSize('big')">
                <img :src="`${url}/gfx/font-size-large.png`" alt="duży tekst" />
            </div>
        </div>
        <!-- skin variants -->
        <div class="flex w-full sm:w-auto items-center justify-center lg:justify-end space-x-4 py-3 lg:py-0">
            <div
                class="w-10 h-10 border border-text rounded flex items-center font-bold justify-center text-xl cursor-pointer transition duration-500 hover:opacity-50"
                @click="changeSkinVarinat('normal')"
            >
                A
            </div>
            <div
                class="w-10 h-10 border border-text bg-text text-white rounded flex items-center font-bold justify-center text-xl cursor-pointer transition duration-500 hover:opacity-50"
                @click="changeSkinVarinat('variant1')"
            >
                A
            </div>
            <div
                class="w-10 h-10 border border-text bg-yellow rounded flex items-center font-bold justify-center text-xl cursor-pointer transition duration-500 hover:opacity-50"
                @click="changeSkinVarinat('variant2')"
            >
                A
            </div>
            <div
                class="w-10 h-10 border border-text bg-text text-yellow rounded flex items-center font-bold justify-center text-xl cursor-pointer transition duration-500 hover:opacity-50"
                @click="changeSkinVarinat('variant3')"
            >
                A
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Wcag",
    data() {
        return {
            url: window.location.protocol + "//" + window.location.host,
            fontSize: "normal",
            skinVariant: "normal",
        };
    },
    methods: {
        changeFontSize(size) {
            const htmlTag = document.querySelector("html");
            if (size === "small") {
                htmlTag.classList.remove("skin-size-big");
                htmlTag.classList.add("skin-size-small");
                this.$cookies.set("fontsize", "small", "1y", "/");
                this.fontSize = "small";
            }
            if (size === "normal") {
                htmlTag.classList.remove("skin-size-small");
                htmlTag.classList.remove("skin-size-big");
                this.$cookies.set("fontsize", "normal", "1y", "/");
                this.fontSize = "normal";
            }
            if (size === "big") {
                htmlTag.classList.remove("skin-size-small");
                htmlTag.classList.add("skin-size-big");
                this.$cookies.set("fontsize", "big", "1y", "/");
                this.fontSize = "big";
            }
        },
        changeSkinVarinat(variant) {
            const htmlTag = document.querySelector("html");
            if (variant === "normal") {
                this.skinVariant = "normal";
                this.$cookies.set("skinvariant", "normal", "1y", "/");
                htmlTag.classList.remove("skin-variant-1");
                htmlTag.classList.remove("skin-variant-2");
                htmlTag.classList.remove("skin-variant-3");
            }
            if (variant === "variant1") {
                this.skinVariant = "variant1";
                this.$cookies.set("skinvariant", "variant1", "1y", "/");
                htmlTag.classList.add("skin-variant-1");
                htmlTag.classList.remove("skin-variant-2");
                htmlTag.classList.remove("skin-variant-3");
            }
            if (variant === "variant2") {
                this.skinVariant = "variant2";
                this.$cookies.set("skinvariant", "variant2", "1y", "/");
                htmlTag.classList.add("skin-variant-2");
                htmlTag.classList.remove("skin-variant-1");
                htmlTag.classList.remove("skin-variant-3");
            }
            if (variant === "variant3") {
                this.skinVariant = "variant3";
                this.$cookies.set("skinvariant", "variant3", "1y", "/");
                htmlTag.classList.add("skin-variant-3");
                htmlTag.classList.remove("skin-variant-1");
                htmlTag.classList.remove("skin-variant-2");
            }
        },
    },
    created() {
        const htmlTag = document.querySelector("html");

        let fontSize = this.$cookies.get("fontsize");
        if (fontSize === "small") {
            htmlTag.classList.remove("skin-size-big");
            htmlTag.classList.add("skin-size-small");
            this.fontSize = "small";
        }
        if (fontSize === "normal") {
            this.fontSize = "normal";
        }
        if (fontSize === "big") {
            htmlTag.classList.remove("skin-size-small");
            htmlTag.classList.add("skin-size-big");
            this.fontSize = "big";
        }

        let skinVariant = this.$cookies.get("skinvariant");
        if (skinVariant === "normal") {
            this.skinVariant = "normal";
            htmlTag.classList.remove("skin-variant-1");
            htmlTag.classList.remove("skin-variant-2");
            htmlTag.classList.remove("skin-variant-3");
        }
        if (skinVariant === "variant1") {
            this.skinVariant = "variant1";
            htmlTag.classList.add("skin-variant-1");
            htmlTag.classList.remove("skin-variant-2");
            htmlTag.classList.remove("skin-variant-3");
        }
        if (skinVariant === "variant2") {
            this.skinVariant = "variant2";
            htmlTag.classList.add("skin-variant-2");
            htmlTag.classList.remove("skin-variant-1");
            htmlTag.classList.remove("skin-variant-3");
        }
        if (skinVariant === "variant3") {
            this.skinVariant = "variant3";
            htmlTag.classList.add("skin-variant-3");
            htmlTag.classList.remove("skin-variant-1");
            htmlTag.classList.remove("skin-variant-2");
        }
    },
};
</script>

<style>
</style>